var exports = {
  "container": "x31de4314--6c82b9--container",
  "text": "x31de4314--6c82b9--text",
  "text-padding-s": "x31de4314--6c82b9--text-padding-s",
  "text-padding-m": "x31de4314--6c82b9--text-padding-m",
};

module.exports = exports;
